
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqpXvNV3IVqZ7r7EZ6X3TxlTw6jDWpvHRhXzG2SNVEy_4Meta } from "/app/pages/faq.vue?macro=true";
import { default as about3BeDYJHafdz3_450F8I84XDeTlPVmsANEPp0qlI_45udm9EMeta } from "/app/pages/about.vue?macro=true";
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as legalhxABOG8I0n54ef6KFswP0gyCvQQNTmpzzgZ6ikxgMyoMeta } from "/app/pages/legal.vue?macro=true";
import { default as loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta } from "/app/pages/login.vue?macro=true";
import { default as terms1wCL_jcKgXyjae_4516VMbFrKHvZd0F4Waht3oN_MqrwYMeta } from "/app/pages/terms.vue?macro=true";
import { default as contactufjgRVR80M94tPXoOoARnsatRQ8kqFsigR6NqG_45FbxIMeta } from "/app/pages/contact.vue?macro=true";
import { default as cookies7IsQMQZ91ParjOwHFEj6VICbqcticg0fuEDXa9tKIEEMeta } from "/app/pages/cookies.vue?macro=true";
import { default as privacyxyrJyjSeOpGN_D08QZsO5Csr7DLueZBtja09XVxe_45u0Meta } from "/app/pages/privacy.vue?macro=true";
import { default as indexXDrvC4X9cQh98rUTaKV7n9SAzKfJcTLnbJGv9g_YdesMeta } from "/app/pages/blog/index.vue?macro=true";
import { default as _91id_93qaJgavNjic8rwGiycVN2TTHAJ8H_H_9dbMbnTXm9AtkMeta } from "/app/pages/trips/[id].vue?macro=true";
import { default as indexUTPWuOuTEHiifiH2gSDbviVYzY2wHbmPaccb9r89Io4Meta } from "/app/pages/admin/index.vue?macro=true";
import { default as _91slug_93YQZPwPwDU4FgBZuc83y_45fmjjiA1deKiIAVltnUukrBsMeta } from "/app/pages/blog/[slug].vue?macro=true";
import { default as index_YjbfTzl09bXXBmegJnZ0mBF8Es91g9xgbFlLbpfpV4Meta } from "/app/pages/trips/index.vue?macro=true";
import { default as accessibilitykJPhdRnYvAfYbQlvjUKjY_45qYBOs51I_YeyB3And3Sm4Meta } from "/app/pages/accessibility.vue?macro=true";
import { default as _91id_93WSS_45ZAqeZYUUN9B52QURmrHjMj7iZUs5lPCo5Ifx1R8Meta } from "/app/pages/my_trips/[id].vue?macro=true";
import { default as pdf_45testDEhmJdRuHqI7qcVdpmamAHiJkGnHLDWuWlou92MI5w0Meta } from "/app/pages/admin/pdf-test.vue?macro=true";
import { default as savedfMu54QikraE68xYXJpuldcFHjj2rCcvp499YaunHx3IMeta } from "/app/pages/my_trips/saved.vue?macro=true";
import { default as mapWulrP8_8WhszuWRY_45PAUZ_vafjdQzhbdHLY50uwW_45wMMeta } from "/app/pages/admin/tools/map.vue?macro=true";
import { default as trip_45summarye0yGo8hnoZx9e7rjNQhkHO9ekuGut7h6jgKOACQ6538Meta } from "/app/pages/pdf/trip-summary.vue?macro=true";
import { default as _91id_93iS7I7tjzjisAgfOWOE3Pbxst6uBfyXGEFzP5ZAkX6_45UMeta } from "/app/pages/trips/activity/[id].vue?macro=true";
import { default as form1fIukA7BDIseC5nm_45GwBxWbiPMWPuhkD1nBZkNaGrDQMeta } from "/app/pages/trips/customize/form.vue?macro=true";
import { default as _91slug_93hWnk8yNy0kMe1BU97rkhQ71HUutvXaL9c02kg26IZIUMeta } from "/app/pages/blog/categoria/[slug].vue?macro=true";
import { default as indexnZJOmYcNxNQbIHbRxHCb_k_Gjj86ktgn26TIL7sxDhYMeta } from "/app/pages/trips/customize/index.vue?macro=true";
import { default as simplezz9cp0z4f5NpNcHP0FuH_vRfAR1IBA_kQQsLJ1EURDkMeta } from "/app/pages/trips/customize/simple.vue?macro=true";
import { default as form2I_45PjOdpI2uokqS4yJMayRcnlyDeNjlW_45bPEJUYJAWoMeta } from "/app/pages/admin/content/trips/form.vue?macro=true";
import { default as image_45uploadcKTG3mP85Q9F63_45VrAt9rVZ7_45fX45g8mkWvtBh42VzUMeta } from "/app/pages/admin/tools/image-upload.vue?macro=true";
import { default as _91id_93wpdFqO_45DetqilM8USoTXq1YFjAra0bzbujH4CgAJu0YMeta } from "/app/pages/trips/accommodation/[id].vue?macro=true";
import { default as formFq1Gh4kbOZ6bIwPWm9HGs68P2MVhUAFzr5neXnRowIgMeta } from "/app/pages/admin/accommodations/form.vue?macro=true";
import { default as indexzIJG8sgvR0as4H4GkylH6KjKh22KOf7HmkP2jnzF3FoMeta } from "/app/pages/admin/content/trips/index.vue?macro=true";
import { default as indexMWNn26HzQgbPZhqXTBrog1TohiBWbaemf5JELuTZN84Meta } from "/app/pages/admin/accommodations/index.vue?macro=true";
import { default as formFHca9wMvWJ_HXpRVu8aLLAcbMzF8G1rfh4GB4ohHF18Meta } from "/app/pages/admin/travel/segments/form.vue?macro=true";
import { default as form97rggf4yBBaZ2CBuy8SL7YonpwkExrYOQC55yP8l0_cMeta } from "/app/pages/admin/travel/trajects/form.vue?macro=true";
import { default as indexUYQX1HuzEg3SnAhYE92IIezRC905jD_hOtEMi5kz77QMeta } from "/app/pages/admin/travel/segments/index.vue?macro=true";
import { default as indexyRgYWPjbhCr2sp42ZaJ1xQVCBbL5tirp_450JGtR49lYcMeta } from "/app/pages/admin/travel/trajects/index.vue?macro=true";
import { default as formByO2tkidktPIl1rGbO18KIIS0fkQ1up9rIe8FEyXFVcMeta } from "/app/pages/admin/travel/transports/form.vue?macro=true";
import { default as formnUmHJuwDHxxlSwRQ_45IO_450exOE1Q0PTnk2KQWmhsPKb4Meta } from "/app/pages/admin/content/activities/form.vue?macro=true";
import { default as indexpfRJh82TuKCe3tD_45NoRcdpkFZyauBvxnL6AUPbLLBhgMeta } from "/app/pages/admin/travel/transports/index.vue?macro=true";
import { default as _91id_93mETtFuEDPFrMLt25s_45EytRInsWXIDawGbc3oZqtQ2tIMeta } from "/app/pages/trips/accommodation/room/[id].vue?macro=true";
import { default as index1Zc9N_45g8ikNGBVZAn0MfcFB3hzOck7vOngRSUIu_hh4Meta } from "/app/pages/admin/content/activities/index.vue?macro=true";
import { default as formP6uBhqrfxXpjltXZoYTJ_1iE_45GDExNpdUFPSCKgqkwQMeta } from "/app/pages/admin/accommodations/rooms/form.vue?macro=true";
import { default as formALdlsbm0pWOpr76YdaGXYfed47W7IbHmyU5o7hDqpc0Meta } from "/app/pages/admin/accommodations/types/form.vue?macro=true";
import { default as forml5YcqXWKakw25NljENBYQxNOdZ6dMCUf8Vq9mNq_45pI8Meta } from "/app/pages/admin/content/destinations/form.vue?macro=true";
import { default as indextVUh9R8opRR47lhPOE6Z35fkWqgu44Ev566mZRNc3P8Meta } from "/app/pages/admin/accommodations/rooms/index.vue?macro=true";
import { default as indexCE3jVRcIM2Dekn2ivmlQs3Gj6JNhW3BHjosLqW9uDBYMeta } from "/app/pages/admin/accommodations/types/index.vue?macro=true";
import { default as indexvR80fs90tLCNBsIe1OPphaNnyTfcYiZ0Ai6NN4vw_45SgMeta } from "/app/pages/admin/content/destinations/index.vue?macro=true";
import { default as formVYjvl3moy6I1Yr_45KQuq5NL2LqsU2Yy158Yi_45f7pU0DgMeta } from "/app/pages/admin/accommodations/regimes/form.vue?macro=true";
import { default as indexvFLO0NdYRKM1E_j86WD_45FJkUZYIGKmQqqIBs89DyL7gMeta } from "/app/pages/admin/accommodations/regimes/index.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    meta: faqpXvNV3IVqZ7r7EZ6X3TxlTw6jDWpvHRhXzG2SNVEy_4Meta || {},
    component: () => import("/app/pages/faq.vue")
  },
  {
    name: "about",
    path: "/about",
    meta: about3BeDYJHafdz3_450F8I84XDeTlPVmsANEPp0qlI_45udm9EMeta || {},
    component: () => import("/app/pages/about.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "legal",
    path: "/legal",
    meta: legalhxABOG8I0n54ef6KFswP0gyCvQQNTmpzzgZ6ikxgMyoMeta || {},
    component: () => import("/app/pages/legal.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: terms1wCL_jcKgXyjae_4516VMbFrKHvZd0F4Waht3oN_MqrwYMeta || {},
    component: () => import("/app/pages/terms.vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: contactufjgRVR80M94tPXoOoARnsatRQ8kqFsigR6NqG_45FbxIMeta || {},
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "cookies",
    path: "/cookies",
    meta: cookies7IsQMQZ91ParjOwHFEj6VICbqcticg0fuEDXa9tKIEEMeta || {},
    component: () => import("/app/pages/cookies.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    meta: privacyxyrJyjSeOpGN_D08QZsO5Csr7DLueZBtja09XVxe_45u0Meta || {},
    component: () => import("/app/pages/privacy.vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/app/pages/blog/index.vue")
  },
  {
    name: "trips-id",
    path: "/trips/:id()",
    component: () => import("/app/pages/trips/[id].vue")
  },
  {
    name: "admin",
    path: "/admin",
    component: () => import("/app/pages/admin/index.vue")
  },
  {
    name: "blog-slug",
    path: "/blog/:slug()",
    component: () => import("/app/pages/blog/[slug].vue")
  },
  {
    name: "trips",
    path: "/trips",
    component: () => import("/app/pages/trips/index.vue")
  },
  {
    name: "accessibility",
    path: "/accessibility",
    meta: accessibilitykJPhdRnYvAfYbQlvjUKjY_45qYBOs51I_YeyB3And3Sm4Meta || {},
    component: () => import("/app/pages/accessibility.vue")
  },
  {
    name: "my_trips-id",
    path: "/my_trips/:id()",
    component: () => import("/app/pages/my_trips/[id].vue")
  },
  {
    name: "admin-pdf-test",
    path: "/admin/pdf-test",
    component: () => import("/app/pages/admin/pdf-test.vue")
  },
  {
    name: "my_trips-saved",
    path: "/my_trips/saved",
    component: () => import("/app/pages/my_trips/saved.vue")
  },
  {
    name: "admin-tools-map",
    path: "/admin/tools/map",
    component: () => import("/app/pages/admin/tools/map.vue")
  },
  {
    name: "pdf-trip-summary",
    path: "/pdf/trip-summary",
    meta: trip_45summarye0yGo8hnoZx9e7rjNQhkHO9ekuGut7h6jgKOACQ6538Meta || {},
    component: () => import("/app/pages/pdf/trip-summary.vue")
  },
  {
    name: "trips-activity-id",
    path: "/trips/activity/:id()",
    component: () => import("/app/pages/trips/activity/[id].vue")
  },
  {
    name: "trips-customize-form",
    path: "/trips/customize/form",
    component: () => import("/app/pages/trips/customize/form.vue")
  },
  {
    name: "blog-categoria-slug",
    path: "/blog/categoria/:slug()",
    component: () => import("/app/pages/blog/categoria/[slug].vue")
  },
  {
    name: "trips-customize",
    path: "/trips/customize",
    component: () => import("/app/pages/trips/customize/index.vue")
  },
  {
    name: "trips-customize-simple",
    path: "/trips/customize/simple",
    component: () => import("/app/pages/trips/customize/simple.vue")
  },
  {
    name: "admin-content-trips-form",
    path: "/admin/content/trips/form",
    component: () => import("/app/pages/admin/content/trips/form.vue")
  },
  {
    name: "admin-tools-image-upload",
    path: "/admin/tools/image-upload",
    component: () => import("/app/pages/admin/tools/image-upload.vue")
  },
  {
    name: "trips-accommodation-id",
    path: "/trips/accommodation/:id()",
    component: () => import("/app/pages/trips/accommodation/[id].vue")
  },
  {
    name: "admin-accommodations-form",
    path: "/admin/accommodations/form",
    component: () => import("/app/pages/admin/accommodations/form.vue")
  },
  {
    name: "admin-content-trips",
    path: "/admin/content/trips",
    component: () => import("/app/pages/admin/content/trips/index.vue")
  },
  {
    name: "admin-accommodations",
    path: "/admin/accommodations",
    component: () => import("/app/pages/admin/accommodations/index.vue")
  },
  {
    name: "admin-travel-segments-form",
    path: "/admin/travel/segments/form",
    component: () => import("/app/pages/admin/travel/segments/form.vue")
  },
  {
    name: "admin-travel-trajects-form",
    path: "/admin/travel/trajects/form",
    component: () => import("/app/pages/admin/travel/trajects/form.vue")
  },
  {
    name: "admin-travel-segments",
    path: "/admin/travel/segments",
    component: () => import("/app/pages/admin/travel/segments/index.vue")
  },
  {
    name: "admin-travel-trajects",
    path: "/admin/travel/trajects",
    component: () => import("/app/pages/admin/travel/trajects/index.vue")
  },
  {
    name: "admin-travel-transports-form",
    path: "/admin/travel/transports/form",
    component: () => import("/app/pages/admin/travel/transports/form.vue")
  },
  {
    name: "admin-content-activities-form",
    path: "/admin/content/activities/form",
    component: () => import("/app/pages/admin/content/activities/form.vue")
  },
  {
    name: "admin-travel-transports",
    path: "/admin/travel/transports",
    component: () => import("/app/pages/admin/travel/transports/index.vue")
  },
  {
    name: "trips-accommodation-room-id",
    path: "/trips/accommodation/room/:id()",
    component: () => import("/app/pages/trips/accommodation/room/[id].vue")
  },
  {
    name: "admin-content-activities",
    path: "/admin/content/activities",
    component: () => import("/app/pages/admin/content/activities/index.vue")
  },
  {
    name: "admin-accommodations-rooms-form",
    path: "/admin/accommodations/rooms/form",
    component: () => import("/app/pages/admin/accommodations/rooms/form.vue")
  },
  {
    name: "admin-accommodations-types-form",
    path: "/admin/accommodations/types/form",
    component: () => import("/app/pages/admin/accommodations/types/form.vue")
  },
  {
    name: "admin-content-destinations-form",
    path: "/admin/content/destinations/form",
    component: () => import("/app/pages/admin/content/destinations/form.vue")
  },
  {
    name: "admin-accommodations-rooms",
    path: "/admin/accommodations/rooms",
    component: () => import("/app/pages/admin/accommodations/rooms/index.vue")
  },
  {
    name: "admin-accommodations-types",
    path: "/admin/accommodations/types",
    component: () => import("/app/pages/admin/accommodations/types/index.vue")
  },
  {
    name: "admin-content-destinations",
    path: "/admin/content/destinations",
    component: () => import("/app/pages/admin/content/destinations/index.vue")
  },
  {
    name: "admin-accommodations-regimes-form",
    path: "/admin/accommodations/regimes/form",
    component: () => import("/app/pages/admin/accommodations/regimes/form.vue")
  },
  {
    name: "admin-accommodations-regimes",
    path: "/admin/accommodations/regimes",
    component: () => import("/app/pages/admin/accommodations/regimes/index.vue")
  }
]